import { render } from "./KnParameterSaveDialog.vue?vue&type=template&id=5712c1ee&scoped=true&ts=true"
import script from "./KnParameterSaveDialog.vue?vue&type=script&lang=ts"
export * from "./KnParameterSaveDialog.vue?vue&type=script&lang=ts"

import "./KnParameterSaveDialog.vue?vue&type=style&index=0&id=5712c1ee&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5712c1ee"]])

export default __exports__